import { createSelector } from "reselect";
import moment from "moment";
import "moment/locale/es";
import { ROLES_RAW } from "../../constants/permissions";
import { resolveRoute } from "../../constants/routes";

moment().locale("es");

/* APP */
export const isUserAuthorized = (state) => state.authorization;
export const getCurrentRouteKey = (state) =>
  state.currentRoute?.key || "projects";
export const getCurrentRoute = createSelector(getCurrentRouteKey, (key) =>
  resolveRoute(key),
);
export const getCurrentRouteTitle = createSelector(
  getCurrentRoute,
  (route) => route?.title,
);
export const getSideMenuState = (state) => state.app?.isCollapsedSideMenu;
export const getCurrentTheme = (state) => state.currentTheme;

/* PROFILE */
export const getUserProfile = (state) => state.profile;
export const currentUserId = createSelector(
  getUserProfile,
  (profile) => profile?.id
);
export const getCurrentUserRole = createSelector(getUserProfile, (profile) =>
  !profile ? null : ROLES_RAW.includes(profile.role) ? profile.role : null
);

/* NOTIFICATIONS STATE */
export const getNotificationsState = (state) => state.notifications;

/* USERS */
export const getUsers = (state) => state.users;
export const getUsersForm = (state) => state.usersForm;

/* ALERT */
export const getAlerts = (state) => state.alerts;
export const getAlertsForm = (state) => state.alertsForm;

/* TASKS */
export const getTasks = (state) => state.tasks;
export const getTasksForm = (state) => state.tasksForm;

/* PROJECTS */
export const getProjects = (state) => state.projects;
export const getProjectsForm = (state) => state.projectsForm;

/* PROJECT CONTROLS */
export const getProjectControls = (state) => state.projectControls;
export const getProjectControlsForm = (state) => state.projectControlsForm;

/* PROJECT TASKS */
export const getProjectTasks = (state) => state.projectTasks;
export const getProjectTasksForm = (state) => state.projectTasksForm;

/* WORKERS */
export const getWorkers = (state) => state.workers;
export const getWorkersForm = (state) => state.workersForm;
